export default "__VITE_ASSET__BOhBnwJi__"